(function () {
    'use strict';

    angular
        .module('invoices')
        .config(InvoicesRoute);

    InvoicesRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function InvoicesRoute($stateProvider) {
        $stateProvider
            .state('root.invoices', {
                disableCache: true,
                abstract: true,
                url: '/invoices',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.invoices.expo', {
                disableCache: true,
                url: '/expo/list',
                data : { invoice_type: 'expo', title: 'Expos' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/expo/list.html',
                        controller: 'InvoicesListController',
                        controllerAs: 'invoicesList',
                        resolve: {
                            invoices: ['InvoicesService', function(InvoicesService) {
                                return InvoicesService.getAll();
                            }]
                        }
                    }
                }
            })
            .state ('root.invoices.user', {
                disableCache: true,
                url: '/expo/user/{id}?expo={expo_id}&invoice_c={invoice_created}&invoice_u={invoice_updated}&error={errors}',
                data : { invoice_type: 'expo', title: 'Expos' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/user/show.html',
                        controller: 'InvoicesUserController',
                        controllerAs: 'invoicesUser',
                    }
                }
            })
            .state ('root.invoices.create', {
                disableCache: true,
                url: '/expo/user/{id}/currency/{currency}/create?{semester}&expo={expo_id}',
                data : { invoice_type: 'expo' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/form/form.html',
                        controller: 'InvoicesFormController',
                        controllerAs: 'invoicesForm'
                    }
                }
            })
            .state ('root.invoices.confirmation', {
                disableCache: true,
                url: '/confirm',
                data : { invoice_type: 'expo' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/form/confirmation/confirmation.html',
                        controller: 'InvoicesConfirmationController',
                        controllerAs: 'invoicesConfirmation',
                        params: {data:null}
                    }
                }
            })
            // Edit invoice Physical Fair
            // .state ('root.invoices.edit', {
            //     disableCache: true,
            //     url: '/expo/user/{id}/{control_id}/{currency}/edit',
            //     data : { invoice_type: 'expo'},
            //     views: {
            //         'inner-view@root': {
            //             templateUrl: 'templates/invoices/form/form.html',
            //             controller: 'InvoicesFormController',
            //             controllerAs: 'invoicesForm',
            //         }
            //     }
            // })
            .state ('root.invoices.virtual_fair', {
                disableCache: true,
                url: '/virtual_fair/list',
                data : { invoice_type: 'virtual_fair', title: 'Virtual Fairs' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/expo/list.html',
                        controller: 'InvoicesListController',
                        controllerAs: 'invoicesList',
                        resolve: {
                            invoices: ['InvoicesService', function(InvoicesService) {
                                return InvoicesService.getAll('virtual_fair');
                            }]
                        }
                    }
                }
            }).state ('root.invoices.virtual_fair.user', {
                disableCache: true,
                url: '/virtual_fair/user/{id}?expo={virtual_fair_id}&invoice_c={invoice_created}&invoice_u={invoice_updated}&error={errors}',
                data : { invoice_type: 'virtual_fair', title: 'Virtual Fairs' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/user/show.html',
                        controller: 'InvoicesUserController',
                        controllerAs: 'invoicesUser',
                        params: {data:null}
                    }
                }
            }).state ('root.invoices.virtual_fair.create', {
                disableCache: true,
                url: '/virtual_fair/user/{id}/currency/{currency}/create?{semester}&expo={expo_id}',
                data : { invoice_type: 'virtual_fair' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/form/form.html',
                        controller: 'InvoicesFormController',
                        controllerAs: 'invoicesForm',
                    }
                }
            }).state ('root.invoices.virtual_fair.confirmation', {
                disableCache: true,
                url: '/confirm',
                data : { invoice_type: 'virtual_fair' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/form/confirmation/confirmation.html',
                        controller: 'InvoicesConfirmationController',
                        controllerAs: 'invoicesConfirmation',
                        params: {data:null}
                    }
                }
            })
            // Edit invoice Virtual
            // .state ('root.invoices.virtual_fair.edit', {
            //     disableCache: true,
            //     url: '/virtual_fair/user/{id}/{control_id}/{currency}/edit',
            //     data : { invoice_type: 'virtual_fair' },
            //     views: {
            //         'inner-view@root': {
            //             templateUrl: 'templates/invoices/form/form.html',
            //             controller: 'InvoicesFormController',
            //             controllerAs: 'invoicesForm',
            //         }
            //     }
            // })

            .state ('root.invoices.general', {
                disableCache: true,
                url: '/general/list?invoice_c={invoice_created}&invoice_u={invoice_updated}&customer={customer_created}',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/general/list.html',
                        controller: 'GeneralInvoicesListController',
                        controllerAs: 'generalInvoicesList'
                    }
                }
            }).state ('root.invoices.general.create', {
                disableCache: true,
                url: '/general/user/{id}/create',
                data : { invoice_type: 'general' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/form/form.html',
                        controller: 'InvoicesFormController',
                        controllerAs: 'invoicesForm',
                    }
                }
            })
            .state ('root.invoices.edit', {
                disableCache: true,
                url: '/{control_id}/edit',
                // data : { invoice_type: 'general' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/edit/form.html',
                        controller: 'InvoicesEditFormController',
                        controllerAs: 'invoicesEditForm',
                    }
                }
            }).state ('root.invoices.general.confirmation', {
                disableCache: true,
                url: '/confirm',
                data : { invoice_type: 'general' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/form/confirmation/confirmation.html',
                        controller: 'InvoicesConfirmationController',
                        controllerAs: 'invoicesConfirmation',
                        params: {data:null}
                    }
                }
            }).state ('root.invoices.general.customer', {
                disableCache: true,
                url: '/customer/create',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/customer/form.html',
                        controller: 'InvoicesCustomerFormController',
                        controllerAs: 'invoicesCustomerForm'
                    }
                }
            }).state ('root.invoices.search', {
                disableCache: true,
                url: '/search?id={control_id}&invoice_c={invoice_created}&invoice_u={invoice_updated}',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/search/list.html',
                        controller: 'SearchInvoicesListController',
                        controllerAs: 'searchInvoicesList'
                    }
                }
            }).state('root.invoices.qbosync', {
                disableCache: true,
                url: '/qbosync/{id}',
                resolve: {
                    sync: ['InvoicesService', '$stateParams', function(InvoicesService, $stateParams) {
                        return InvoicesService.qboSync($stateParams.id);
                    }]
                },
            })
            .state('root.invoices.overview', {
                disableCache: true,
                url: '/overview',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/overview/list.html',
                        controller: 'InvoicesOverviewController',
                        controllerAs: 'invoicesOverview'
                    }
                }
            }).state('root.invoices.invoice_payment', {
                disableCache: true,
                url: '/invoice_payment',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/invoice-payment/list.html',
                        controller: 'InvoicePaymentListController',
                        controllerAs: 'invoicePaymentList'
                    }
                }
            }).state ('root.invoices.cost_center', {
                disableCache: true,
                url: '/cost_center',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/invoices/cost-center/list.html',
                        controller: 'CostCenterListController',
                        controllerAs: 'costCenterList'
                    }
                }
            }).state('root.invoices.admin_commissions', {
                disableCache: true,
                url: '/admin_commissions',
                resolve: {
                    commissions: ['InvoicesService', function(InvoicesService) {
                        return InvoicesService.create_admin_commissions();
                    }]
                },
            }).state('root.invoices.vf_commissions', {
                disableCache: true,
                url: '/vf_commissions/{seller_id}/{from}',
                resolve: {
                    commissions: ['InvoicesService', '$stateParams', function(InvoicesService, $stateParams) {
                        return InvoicesService.create_vf_commissions($stateParams.seller_id, $stateParams.from);
                    }]
                },
            }).state('root.invoices.pr_commissions', {
                disableCache: true,
                url: '/pr_commissions/{seller_id}/{from}',
                resolve: {
                    commissions: ['InvoicesService', '$stateParams', function(InvoicesService, $stateParams) {
                        return InvoicesService.create_pr_commissions($stateParams.seller_id, $stateParams.from);
                    }]
                },
            });
    }
})();
